import { Fragment } from 'react';

import { Money } from 'components';
import { PayoutOrder } from 'types';

export const PayoutOrderAmount = ({
  order,
  isMerchant,
}: {
  order: PayoutOrder;
  isMerchant: boolean;
}) => (
  <Fragment>
    <Money value={order.amount} fiatCurrencyId={order.fiatCurrencyId} symbol />
    <div>
      <Money
        value={
          isMerchant
            ? order.assetCurrencyAmount
            : order.traderAssetCurrencyAmount ?? order.assetCurrencyAmount
        }
        assetCurrencyId={order.assetCurrencyId}
        symbol
      />
      {' ('}
      <Money
        value={
          isMerchant
            ? order.currencyRate
            : order.traderCurrencyRate ?? order.currencyRate
        }
        fiatCurrencyId={order.fiatCurrencyId}
        symbol
      />
      {')'}
    </div>
  </Fragment>
);
